$('input[type="file"]').each(function() {
	var $input = $(this),
		$label = $input.next('label'),
		$form = $input.closest('form'),
		labelVal = $label.html();

	$input.on('change', function(e) {
		var fileName = '';

		if (this.files && this.files.length > 1)
			fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
		else if (e.target.value) fileName = e.target.value.split('\\').pop();

		if (fileName) $label.html(fileName);
		else $label.html(labelVal);

		if($form.find('.form__actions').length > 0) {
			$form.find('.form__actions button').prop('disabled', false);
		}
	});

	// Firefox bug fix
	$input
		.on('focus', function() {
			$input.addClass('has-focus');
		})
		.on('blur', function() {
			$input.removeClass('has-focus');
		});
});

$('.form-contact .checkbox input').on('change', function(e) {
	const $this = $(this);

	if ($this.is(':checked')) {
		$this
			.closest('.checkbox')
			.next()
			.prop('disabled', false)
			.focus();
	} else {
		$this
			.closest('.checkbox')
			.next()
			.prop('disabled', true);
	}
});

var flag = false;

$('.form-contact form').on('submit', function(e) {
	if (!flag) {
		e.preventDefault();

		if($(this).hasClass('upload-form')) {
			let form = document.querySelector('form.upload-form');
			var params = new FormData(form);
			let url = $(this).data('endpoint') + $(this).attr('action');
			$.ajax({
				type: "POST",
				enctype: 'multipart/form-data',
				url: url,
				data: params,
				processData: false,
				contentType: false,
				cache: false,
				timeout: 600000,
				dataType: 'json',
				success: function (data) {
					$('#FileUpload').val('');
					$('#field-upload-orderid').val('');
					$('#field-upload-quoteid').val('');
					$('#field-upload-message').val('');
					
					$('label.form__file').text('Choose File');

					$('.upload-form .form__btn')
						.prop('disabled', true)
						.css('font-size', '14px')
						.children('i')
						.addClass('hidden');
				},
				error: function (e) {
					
				}
			});
		} else {
			$.ajax({
				url: $(this).attr('action'),
				type: 'post',
				dataType: 'html',
				data: $(this).serialize()
			})
				.done(function(data) {
					$('.form-contact').hide();

					$('.form-message').show();
				})
				.fail(function(data) {
					console.log('fail:', data);

					flag = true;

					$('.form-contact form').trigger('submit');
				});
		}
	}
});

$('.form-contact').on('click', '.form__btn', function() {
	$(this)
		.css('font-size', 0)
		.children('i')
		.removeClass('hidden');
});

$('form.upload-form').on('click', '.form__btn', function() {
	$('form.upload-form').trigger('submit');
});




// WEBPACK FOOTER //
// ../assets/js/contact.js